import { useTranslation } from 'react-i18next';

import { intentRow } from './AmendRows';
import {
  buildNodeRow,
  buildStepRows,
  buildTextSentRow,
  buildUnderstandRows,
  useAfterAnswerRows,
} from './buildStepRows';
import { DetailRows, DetailRowSpec } from './DetailsRow';
import { getIntentInfo } from './IntentDetail';
import { buildToolRows } from './ToolsRows';
import { ConversationTurn } from '../../../types/conversation';

type MCPDetailsProps = { turn: ConversationTurn; grouped?: boolean };

/** MCP variant: what the user asked → intent → the agent's tools → the answer → Moveo's tools. */
export const MCPDetails = ({ turn, grouped }: MCPDetailsProps) => {
  const { t } = useTranslation();

  const intentInfo = getIntentInfo(turn);
  const answerRows = useAfterAnswerRows(turn);

  const rows: (DetailRowSpec | false | undefined | null)[] = [
    ...buildUnderstandRows(t, turn),
    intentInfo.hasInfo && { ...intentRow(turn), phase: 'understand' as const },
    buildNodeRow(t, turn),
    ...buildToolRows(turn, 'agent'),
    ...buildStepRows(t, turn, answerRows),
    buildTextSentRow(t, turn),
  ];

  return <DetailRows rows={rows} grouped={grouped} />;
};
